import { useEffect, useState } from "react";
import Lenis from "lenis";
import axios from "axios";
import "@/App.css";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LangProvider } from "@/i18n";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import EssaiSection from "@/components/EssaiSection";
import VideoSection from "@/components/VideoSection";
import Footer from "@/components/Footer";
import Admin from "@/pages/Admin";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import DemoExperience from "@/pages/DemoExperience";

const Landing = () => {
  const [today, setToday] = useState(null);
  useEffect(() => {
    axios.get(`${API}/demo/today`).then(({ data }) => setToday(data)).catch(() => {});
  }, []);
  return (
    <div className="bg-[#050505] text-white min-h-screen font-body antialiased">
      <Header />
      <main>
        <Hero today={today} />
        <EssaiSection today={today} />
        <VideoSection />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <LangProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/demo" element={<DemoExperience />} />
        </Routes>
      </BrowserRouter>
    </LangProvider>
  );
}

export default App;
